var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sendMessageInfo"},[_c('k-dialog',{ref:"sendEmailDialog",staticClass:"uploadModel",attrs:{"options":{
      title:_vm.title,
      center: true,
      width: '30%',
      top: '0',
      destroyOnClose: true,
      isCanClickClose: false,
      showClose: true,
      onCloseBefore: _vm.closeEmail,
      buttons: [
        // { text: '取消', handler: closeMsg },
        // { text: '确定', handler: closeMsg }
      ]
    }}},[_c('div',{staticClass:"openModal"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"update_main"},[_c('div',{staticClass:"item"},[_c('el-form',{attrs:{"model":{}}},[_c('k-input',{ref:"EMAIL",attrs:{"id":"EMAIL","label":_vm.label,"value":_vm.EMAIL,"validtype":"email|on-change","buttontxt":"发送邮件","correct":_vm.correct,"clickButton":_vm.sendEmail,"required":true},on:{"update:value":function($event){_vm.EMAIL=$event},"update:correct":function($event){_vm.correct=$event}}})],1)],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc45bee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/components/imageNode/child/sendEmail.vue
// module id = 1124
// module chunks = 2